module.exports = __webpack_public_path__ + "img/vi.b219f68d.svg";